<a href="javascript:;" (click)="close()" class="close-btn"><i class="far fa-times"></i></a>
<div class="modal-body bg-none d-flex flex-column align-items-center m-0 px-5 py-4 gap-3">
  <img src="/assets/images/messaging/gmail-chat.webp" alt="" style="width: 15rem" />
  <h5 class="mb-0" i18n>Connect Gmail for Seamless Guest Communication!</h5>
  <p class="mb-0" i18n>
    Manage guest emails effortlessly! Integrate Gmail into your Unified Inbox to track conversations, automate
    responses, and keep all guest interactions in one place—efficient and hassle-free.
  </p>
  <div class="w-50">
    <button class="btn btn-secondary w-100" (click)="onConnect()">
      <i class="fab fa-google text-xxl"></i> <ng-container i18n>Connect Gmail Now</ng-container>
    </button>
  </div>
  <div class="text-muted text-sm" i18n>100% Free - No Subscription, No Hidden Fees!</div>
</div>
